import { MenuItem } from 'src/app/shared/page/menu.types';

export interface SidebarItem {
  name: string;
  icon?: string;
  label: string;
  callback?: () => void;
  children?: SidebarItem[];
}

export function menuItemsToSidebarItems<
  TMenuParams,
  TMenuItemName extends string,
>(
  menuItems: MenuItem<TMenuParams, TMenuItemName>[],
  params: TMenuParams,
  localization: Record<TMenuItemName, string>,
  menuItemCallback: (menuItem: TMenuItemName) => (() => void) | undefined,
): SidebarItem[] {
  const sidebarItems: SidebarItem[] = [];
  menuItems.forEach(menuItem => {
    const show = !menuItem.showIf || menuItem.showIf(params);
    if (!show) {
      return;
    }
    const children = menuItem.children
      ? menuItemsToSidebarItems(
          menuItem.children,
          params,
          localization,
          menuItemCallback,
        )
      : undefined;
    const label = localization[menuItem.name];
    const callback = menuItemCallback(menuItem.name);
    const sidebarItem = {
      ...menuItem,
      label,
      children,
      callback,
    };
    sidebarItems.push(sidebarItem);
  });
  return sidebarItems;
}

export enum SidebarServiceRequestKind {
  show = 'show',
  toggle = 'toggle',
}

export type SidebarServiceRequest =
  | {
      kind: SidebarServiceRequestKind.show;
      show: boolean;
    }
  | {
      kind: SidebarServiceRequestKind.toggle;
    };

export const SidebarServiceRequest = {
  [SidebarServiceRequestKind.show]: (show: boolean): SidebarServiceRequest => ({
    kind: SidebarServiceRequestKind.show,
    show,
  }),
  [SidebarServiceRequestKind.toggle]: (): SidebarServiceRequest => ({
    kind: SidebarServiceRequestKind.toggle,
  }),
};
